import frontViewNight from "../assets/frontView.jpg";
import frontViewDay from "../assets/frontView.webp";
import searedGnocchi from "../assets/searedGnocchi.png";
import aglio from "../assets/aglioeolio.png";
import rigatoni from "../assets/rigatoniVodka.png";
import wildRavioli from "../assets/wildRavioli.png";
import chickenPiccata from "../assets/chickenPiccata.png";
import qrCode from "../assets/QRCode.png";
import "./styles.css";

const dishes = [
  {
    name: "Seared Gnocchi Cacio e Pepe",
    image: searedGnocchi,
    alt: "Seared gnocchi cacio e pepe",
  },
  {
    name: "Aglio e Olio",
    image: aglio,
    alt: "Aglio e Olio",
  },
  {
    name: "Rigatoni alla Vodka",
    image: rigatoni,
    alt: "Rigatoni alla Vodka",
  },
  {
    name: "White Truffle Mushroom Ravioli",
    image: wildRavioli,
    alt: "White Truffle Wild Mushroom Ravioli",
  },
  {
    name: "Chicken Piccata",
    image: chickenPiccata,
    alt: "Chicken Piccata",
  },
];

function SignatureDish({ name, image, alt }) {
  return (
    <div className="featured-item">
      <h3>{name}</h3>
      <div className="featured-dish">
        <img src={image} alt={alt} />
      </div>
    </div>
  );
}

function Home() {
  const handleOrderClick = () => {
    window.open(
      "https://www.makeitbutter.com/masse-cafe/clearwater",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleGiftCardClick = () => {
    window.open(
      "https://www.makeitbutter.com/masse-cafe/egift-card",
      "_blank",
      "noopener,noreferrer"
    );
  };

  // Determine current hour to switch between day and night images
  const currentHour = new Date().getHours();
  const isDaytime = currentHour >= 6 && currentHour < 18;
  const frontViewImg = isDaytime ? frontViewDay : frontViewNight;

  return (
    <div className="home-page">
      <section className="hero-section">
        <div>
          <img src={frontViewImg} alt="Front view of the store" />
        </div>
        <div className="hero-content">
          <h1>Welcome to Café Massé</h1>
          <p>where authenticity meets innovation</p>
          <button onClick={handleOrderClick} className="order-button">
            Order Online
          </button>
          <br />
          <br />
          <button onClick={handleGiftCardClick} className="order-button">
            Buy Gift Cards
          </button>
          <br />
          <div className="qr-code">
            <img src={qrCode} alt="QR Code for ordering online" />
          </div>
        </div>
      </section>

      <section className="featured-section">
        <h2>Signature Dishes</h2>
        <div className="featured-items">
          {dishes.map((dish, idx) => (
            <SignatureDish key={idx} {...dish} />
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;
